import { SchedulablePresenter } from 'shared/presenters/SchedulablePresenter'
import { AddABookingValues } from 'helpers/generateInitialValuesForActivity'
import { definedNotNull } from 'shared/presenters/presenter'

export const determineOptionalExtrasInitialValues = (
  schedulable: SchedulablePresenter
): AddABookingValues['optionalExtra'] | undefined => {
  if (
    !schedulable?.optional_extras ||
    schedulable?.optional_extras.length === 0
  ) {
    return undefined
  }
  const optionalExtra: AddABookingValues['optionalExtra'] = {}
  schedulable.optional_extras.forEach(item => {
    optionalExtra[definedNotNull(item.id)] = 0
  })

  return { ...optionalExtra }
}
